import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';
import { determineUnread } from '../function/determine-unread.function';
import { filterItems } from '../function/filter-items.function';
import { itemTransformer } from '../transformer/item.transformer';

import { ReceiveItems } from './receive-items.action';

export function receiveItemsReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType, ReceiveItems>,
): EventCentreDialogState {
    try {
        const nextItems = [
            ...state.items,
            ...itemTransformer(action.payload.items, state.navCategories),
        ];

        const nextCategories = determineUnread(state.categories, nextItems);
        const nextNavCategories = nextCategories.slice(1);

        const nextFilt = filterItems({
            items: nextItems,
            categoryId: state.categoryId,
            filterOpts: state.filterOpts,
            categories: state.categories,
            orderBy: state.orderBy,
        });

        return {
            ...state,
            categories: nextCategories,
            navCategories: nextNavCategories,
            items: nextItems,
            filteredItems: nextFilt,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
